<template>
  <div>
    <el-page-header class="detail-head" @back="goBack">
      <template v-slot:content>
        <div class="toolbar">
          <span>送检订单详情</span>
          <div class="toolbar-items">
            <el-button size="mini" type="success" @click="audit">审核通过</el-button>
            <el-button size="mini" type="success" @click="receiptGoods">签收仪器</el-button>
            <el-button size="mini" type="primary" @click="detection">确认送检完成</el-button>
            <el-button size="mini" type="danger" @click="receiptMoney">确认收款</el-button>
            <el-button size="mini" type="primary" @click="returnGoods">确认返货完成</el-button>
            <el-dropdown split-button type="warning" size="mini" class="split-button">
              撤销
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="revokeAudit">撤销提交</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>
      </template>
    </el-page-header>

    <el-divider class="detail-divider"></el-divider>
    <el-tabs>
      <el-tab-pane label="订单信息">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="130px">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="订单号" class="detail-form-item" prop="code">
                      <el-input size="medium" v-model="entity.code"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="订单名称" class="detail-form-item" prop="name">
                      <el-input size="medium" v-model="entity.name"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="用户名称" class="detail-form-item">
                      <el-input size="medium" v-model="entity.user.realName" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="订单状态" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.state">
                        <el-option v-for="item in states" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="送检单位名称" class="detail-form-item">
                      <el-input size="medium" v-model="entity.insCoName"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="送检单位地址" class="detail-form-item">
                      <el-input size="medium" v-model="entity.insCoAddress"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="送检单位联系人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.insCoPerson"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="送检单位电话" class="detail-form-item">
                      <el-input size="medium" v-model="entity.insCoPhone"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="证书单位名称" class="detail-form-item">
                      <el-input size="medium" v-model="entity.certCoName"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="证书单位地址" class="detail-form-item">
                      <el-input size="medium" v-model="entity.certCoAddress"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="证书单位联系人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.certCoPerson"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="证书单位电话" class="detail-form-item">
                      <el-input size="medium" v-model="entity.certCoPhone"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="提交时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.submitTime" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="审核时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.auditTime" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="发货时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.sendTime" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="签收仪器时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.receiptGoodsTime" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="提交检测时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.detectTime" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="检测完成时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.detectFinishTime" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="确认检测完成时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.detectConfirmTime" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="上传汇款时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.uploadRemitTime" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="确认汇款时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.receiptMoneyTime" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="确认返货时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.returnGoodsTime" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="撤销提交时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.revokeAuditTime" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="取消订单时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.cancelTime" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="订单完成时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.finishTime" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.creator" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="grid-content">
                    <el-form-item label="备注" class="detail-form-item">
                      <el-input type="textarea" v-model="entity.remark"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="仪器详情">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-alert v-if="error" title="表格验证提示：" type="error" :description="error" show-icon>
            </el-alert>
            <el-table :data="entity.inspectDetails" border style="width: 100%" @row-click="rowClick">
              <el-table-column prop="no" label="序号" width="50"> </el-table-column>
              <el-table-column prop="name" label="仪器名称" width="200">
                <template #default="scope">
                  <div v-if="scope.row.edit">
                    <input v-model.lazy="scope.row.name" class="el-input__inner input-row-edit" />
                  </div>
                  <div v-else>
                    {{scope.row.name}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="model" label="仪器型号" width="100">
                <template #default="scope">
                  <div v-if="scope.row.edit">
                    <input v-model.lazy="scope.row.model" class="el-input__inner input-row-edit" />
                  </div>
                  <div v-else>
                    {{scope.row.model}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="factoryNumber" label="出厂编号" width="140">
                <template #default="scope">
                  <div v-if="scope.row.edit">
                    <input v-model.lazy="scope.row.factoryNumber" class="el-input__inner input-row-edit" />
                  </div>
                  <div v-else>
                    {{scope.row.factoryNumber}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="certCompanyName" label="仪器生产厂家" width="200">
                <template #default="scope">
                  <div v-if="scope.row.edit">
                    <input v-model.lazy="scope.row.certCompanyName" class="el-input__inner input-row-edit" />
                  </div>
                  <div v-else>
                    {{scope.row.certCompanyName}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="insTypeName" label="送检类型" width="100">
                <template #default="scope">
                  <div v-if="scope.row.edit">
                    <el-select size="mini" v-model="scope.row.insType" @change="changeInsType(scope.row)">
                      <el-option v-for="item in insTypes" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                      </el-option>
                    </el-select>
                  </div>
                  <div v-else>
                    {{scope.row.insTypeName}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="preDate" label="上次送检日期" width="140">
                <template #default="scope">
                  <div v-if="scope.row.edit">
                    <el-date-picker style="width:126px;" size="mini" v-model="scope.row.preDate" type="date" value-format="YYYY-MM-DD">
                    </el-date-picker>
                  </div>
                  <div v-else>
                    {{scope.row.preDate}}
                  </div>
                </template>

              </el-table-column>
              <el-table-column prop="insPeriod" label="送检周期" width="120">
                <template #default="scope">
                  <div v-if="scope.row.edit">
                    <el-input-number style="width:100px" size="mini" v-model.lazy="scope.row.insPeriod" :precision="1" :step="0.1" :max="10" controls-position="right"></el-input-number>
                  </div>
                  <div v-else>
                    {{scope.row.insPeriod}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="certTypeName" label="证书类型" width="100">
                <template #default="scope">
                  <div v-if="scope.row.edit">
                    <el-select size="mini" v-model="scope.row.certType" @change="changeCertType(scope.row)">
                      <el-option v-for="item in insCcieTypes" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                      </el-option>
                    </el-select>
                  </div>
                  <div v-else>
                    {{scope.row.certTypeName}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="testOrganization" label="检定机构" width="180">
                <template #default="scope">
                  <div v-if="scope.row.edit">
                    <input v-model.lazy="scope.row.testOrganization" class="el-input__inner input-row-edit" />
                  </div>
                  <div v-else>
                    {{scope.row.testOrganization}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="firstName" label="是否初次" width="100">
                <template #default="scope">
                  <div v-if="scope.row.edit">
                    <el-select size="mini" v-model="scope.row.first" @change="changeFirst(scope.row)">
                      <el-option label="是" :value="true"> </el-option>
                      <el-option label="否" :value="false"> </el-option>
                    </el-select>
                  </div>
                  <div v-else>
                    {{scope.row.firstName}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注信息">
                <template #default="scope">
                  <div v-if="scope.row.edit">
                    <input v-model.lazy="scope.row.remark" class="el-input__inner input-row-edit" />
                  </div>
                  <div v-else>
                    {{scope.row.remark}}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="发票信息">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-form class="detail-form" label-width="120px">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="发票类型" class="detail-form-item">
                      <el-input size="medium" v-model="entity.invoice.typeName" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="单位名称" class="detail-form-item">
                      <el-input size="medium" v-model="entity.invoice.companyName" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="纳税人识别号" class="detail-form-item">
                      <el-input size="medium" v-model="entity.invoice.taxpayerId" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="注册地址" class="detail-form-item">
                      <el-input size="medium" v-model="entity.invoice.address" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="开票信息电话" class="detail-form-item">
                      <el-input size="medium" v-model="entity.invoice.phone" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="开户银行" class="detail-form-item">
                      <el-input size="medium" v-model="entity.invoice.bank" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="银行账号" class="detail-form-item">
                      <el-input size="medium" v-model="entity.invoice.bankAccount" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="电子发票" class="detail-form-item">
                      <el-input size="medium" :value="entity.invoice.electronic?'是':'否'" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="电子发票邮箱" class="detail-form-item">
                      <el-input size="medium" v-model="entity.invoice.email" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="物流信息">
        <div class="detail-containe-product">
          <el-tabs v-model="expressActiveName" tab-position="left" style="height:100%">
            <el-tab-pane name="first" label="发货信息">
              <el-form class="express" label-width="100px">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="发货类型">
                      <el-input size="medium" v-model="entity.sendExpress.transportModeName" readonly></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="发货物流单号">
                      <el-input size="medium" type="textarea" :rows="5" v-model="entity.sendExpress.expressNumbers" placeholder="多个单号请使用逗号分割"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-tab-pane>
            <el-tab-pane name="second" label="返货信息">
              <el-form ref="formExpress" class="express" v-if="entity.deliveryAddress" label-width="100px">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="返货地址">
                      <el-input size="medium" v-model="entity.deliveryAddress.fullAddress"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="返货联系人">
                      <el-input size="medium" v-model="entity.deliveryAddress.contactPerson"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="返货联系电话">
                      <el-input size="medium" v-model="entity.deliveryAddress.phone"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="返货邮编">
                      <el-input size="medium" v-model="entity.deliveryAddress.postalCode"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="客户指定物流公司">
                      <el-input size="medium" v-model="entity.deliveryExpress.nominatedExpress"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="是否保价">
                      <el-radio-group v-model="entity.deliveryExpress.insured">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="保价金额">
                      <el-input size="medium" v-model="entity.deliveryExpress.insuredMoney"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="是否包含精密仪器">
                      <el-radio-group v-model="entity.deliveryExpress.precise">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="返货物流公司">
                      <el-input size="medium" v-model="entity.deliveryExpress.expressName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="返货时间">
                      <el-date-picker size="medium" v-model="entity.deliveryExpress.sendTime" type="datetime" value-format="YYYY-MM-DD HH:mm:ss" placeholder="选择日期时间">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="返货物流单号">
                      <el-input size="medium" type="textarea" :rows="5" v-model="entity.deliveryExpress.expressNumbers" placeholder="多个单号请使用逗号分割"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-tab-pane>
      <el-tab-pane label="送检委托单">
        <div class="detail-containe-product">
          <div class="delegate-btns">
            <el-button size="mini" type="primary" @click="addDelegate">填写委托单</el-button>
          </div>
          <el-table :data="delegateList" stripe size="medium" border>
            <el-table-column type="index" width="50" label="序号" />
            <el-table-column prop="code" label="委托单号" width="120"> </el-table-column>
            <el-table-column prop="name" label="委托单名称" width="200"> </el-table-column>
            <el-table-column prop="stateName" label="状态" width="100"> </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="160"> </el-table-column>
            <el-table-column prop="modifyTime" label="检测完成时间" width="160"> </el-table-column>
            <el-table-column prop="testCount" label="检测数量" width="100"> </el-table-column>
            <el-table-column prop="finishedTestCount" label="已完成数量" width="100"> </el-table-column>
            <el-table-column prop="unfinishedTestCount" label="未完成数量" width="100"> </el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column label="操作" width="100">
              <template #default="scope">
                <el-button type="success" size="mini" @click="goDelegate(scope.row)">查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="汇款凭证">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-form label-width="80px">
              <el-form-item label="汇款图片">
                <el-image :src="entity.remitImg">
                  <template #error>
                    <span>未上传</span>
                  </template>
                </el-image>
              </el-form-item>
            </el-form>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="送检合同">
        <div class="contract">
          <div class="contract-content">
            <div class="contract-toolbar">
              <el-button size="mini" type="success" @click="download">下载合同</el-button>
            </div>
            <iframe name="toppage" width=100% height=100% marginwidth=0 marginheight=0 frameborder="no" border="0" :src="entity.contractHtmlUrl"></iframe>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import {
  Delegate,
  Inspect,
  InspectExpress,
} from "@/script/apps/inspect/entity/InspectEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { InspectService } from "@/script/apps/inspect/service/InspectService";
import { ElMessage, ElMessageBox } from "element-plus";
import { DictService } from "@/script/apps/system/service/DictService";
import { Dict } from "@/script/apps/system/entity/SystemEntity";
import bus from "@/script/core/util/Bus";
import { MenuData } from "@/script/core/base/MenuData";
import { DelegateService } from "@/script/apps/inspect/service/DelegateService";

@Options({})
export default class InspectDetail extends BaseDetail {
  private service = new InspectService();

  private insTypes: Dict[] = [];

  private insCcieTypes: Dict[] = [];

  private invoiceTypes: Dict[] = [];

  private sendTypes: Dict[] = [];

  private delegateStates: Dict[] = [];

  private delegateList: Delegate[] = [];

  private expressActiveName = "second";

  private error: string | null = null;

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_ins_inspect",
      "/ins/inspect",
      "/ins/inspect",
      this.service
    );
    data.entity = {
      user: { realName: "" },
      invoice: {},
      sendAddress: {},
      sendExpress: {},
      deliveryAddress: {},
      deliveryExpress: {},
    };
    data.statesName = "ins-order-state";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
  };

  public newEntity() {
    const entity: Inspect = {};
    return entity;
  }

  changeInsType(row: any) {
    row.insTypeName = DictUtil.getItemName(this.insTypes, row.insType);
  }

  changeCertType(row: any) {
    row.certTypeName = DictUtil.getItemName(this.insCcieTypes, row.certType);
  }

  changeFirst(row: any) {
    row.firstName = row.first ? "是" : "否";
  }

  private isEmpty(value: string | null | undefined): boolean {
    if (value === undefined) {
      return true;
    }
    if (value === null) {
      return true;
    }
    value = value.trim();
    if (value.length === 0) {
      return true;
    }
    return false;
  }

  protected initOptions() {
    super.initOptions();

    const dictService = new DictService();
    dictService.loadChildItems("ins-ccie-type", (data: any) => {
      this.insCcieTypes = data;
    });
    dictService.loadChildItems("ins-type", (data: any) => {
      this.insTypes = data;
    });
    dictService.loadChildItems("uc-invoice-type", (data: any) => {
      this.invoiceTypes = data;
    });
    dictService.loadChildItems("ins-send-type", (data: any) => {
      this.sendTypes = data;
    });
    dictService.loadChildItems("ins-delegate-state", (data: any) => {
      this.delegateStates = data;
    });
  }

  public afterLoad() {
    const inspect = this.entity as Inspect;
    inspect.deleteInspectDetails = [];
    this.injectDetailData(
      inspect.inspectDetails!,
      inspect.deleteInspectDetails!
    );
    this.generateRowNo();
    inspect.inspectDetails!.forEach((item) => {
      item.insTypeName = DictUtil.getItemName(this.insTypes, item.insType);
      item.certTypeName = DictUtil.getItemName(
        this.insCcieTypes,
        item.certType
      );
      item.firstName = item.first ? "是" : "否";
    });
    inspect.invoice!.typeName = DictUtil.getItemName(
      this.invoiceTypes,
      inspect.invoice!.type
    );

    const delegateService = new DelegateService();
    delegateService.loadDelegateListByOrder(inspect.id!, (data: any) => {
      this.delegateList = data;
      this.delegateList.forEach((delegate) => {
        delegate.stateName = DictUtil.getItemName(
          this.delegateStates,
          delegate.state!
        );
      });
    });

    if (inspect.sendExpress) {
      inspect.sendExpress.transportModeName = DictUtil.getItemName(
        this.sendTypes,
        inspect.sendExpress?.transportMode
      );
    }
    if (inspect.deliveryExpress) {
      inspect.deliveryExpress.preciseName = inspect.deliveryExpress.precise
        ? "是"
        : "否";
      inspect.deliveryExpress.insuredName = inspect.deliveryExpress.insured
        ? "是"
        : "否";
    }
  }

  private addDelegate() {
    const delegateData = ServiceFactory.build(
      "biz_ins_delegate",
      "/ins/delegate",
      "/ins/delegate",
      this.service
    );

    this.$router.push({
      path: delegateData.detailUrl,
      query: { id: 0, type: "A", cache: "0", inspectId: this.entity.id },
    });

    const menuData: MenuData = {
      name: delegateData.listUrl,
      path: delegateData.detailUrl,
      title: String("委托单"),
      query: { type: "A", cache: "1", inspectId: this.entity.id },
      isClose: true,
    };
    bus.emit("menu-select", menuData);
  }

  private goDelegate(data: any) {
    const delegateData = ServiceFactory.build(
      "biz_ins_delegate",
      "/ins/delegate",
      "/ins/delegate",
      this.service
    );

    this.$router.push({
      path: delegateData.detailUrl,
      query: { id: data.id, type: "M", cache: "0" },
    });

    const menuData: MenuData = {
      name: delegateData.listUrl,
      path: delegateData.detailUrl,
      title: String("委托单"),
      query: { id: data.id, type: "M", cache: "1" },
      isClose: true,
    };
    bus.emit("menu-select", menuData);
  }

  private audit() {
    ElMessageBox.confirm("此操作将[审核订单], 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const inspect = this.entity as Inspect;
        this.service.action(
          "/api/ins/inspect/audit",
          inspect,
          (data: any) => {
            ElMessage({ type: "success", message: data.message });
            this.load(this.id);
          },
          function (error: Error) {
            ElMessage.error(error.message);
          }
        );
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消操作",
        });
      });
  }

  private revokeAudit() {
    ElMessageBox.confirm("此操作将[撤销提交], 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const inspect = this.entity as Inspect;
        this.service.action(
          "/api/ins/inspect/revoke_audit",
          inspect,
          (data: any) => {
            ElMessage({ type: "success", message: data.message });
            this.load(this.id);
          },
          function (error: Error) {
            ElMessage.error(error.message);
          }
        );
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消操作",
        });
      });
  }

  private receiptGoods() {
    ElMessageBox.confirm("此操作将[签收仪器], 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const inspect = this.entity as Inspect;
        this.service.action(
          "/api/ins/inspect/receipt_goods",
          inspect,
          (data: any) => {
            ElMessage({ type: "success", message: data.message });
            this.load(this.id);
          },
          function (error: Error) {
            ElMessage.error(error.message);
          }
        );
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消操作",
        });
      });
  }

  private detection() {
    ElMessageBox.confirm("此操作将[确认提交送检], 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const inspect = this.entity as Inspect;
        const errors: string[] = [];
        inspect.inspectDetails!.forEach((item) => {
          if (this.isEmpty(item.factoryNumber)) {
            errors.push(`第 [${item.no}] 行的 [出厂编号] 不能为空！`);
          }
        });
        if (errors.length > 0) {
          this.error = errors.join("");
          ElMessage.error(`验证表格内容失败!具体原因请查看表格上方提示。`);
          return false;
        } else {
          this.error = null;
        }

        this.service.action(
          "/api/ins/inspect/detection",
          inspect,
          (data: any) => {
            ElMessage({ type: "success", message: data.message });
            this.load(this.id);
          },
          function (error: Error) {
            ElMessage.error(error.message);
          }
        );
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消操作",
        });
      });
  }

  private detectionComplete() {
    ElMessageBox.confirm("此操作将[确认检测完成], 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const inspect = this.entity as Inspect;
        this.service.action(
          "/api/ins/inspect/detection_complete",
          inspect,
          (data: any) => {
            ElMessage({ type: "success", message: data.message });
            this.load(this.id);
          },
          function (error: Error) {
            ElMessage.error(error.message);
          }
        );
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消操作",
        });
      });
  }

  private receiptMoney() {
    ElMessageBox.confirm("此操作将[确认收款], 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const inspect = this.entity as Inspect;
        this.service.action(
          "/api/ins/inspect/receipt_money",
          inspect,
          (data: any) => {
            ElMessage({ type: "success", message: data.message });
            this.load(this.id);
          },
          function (error: Error) {
            ElMessage.error(error.message);
          }
        );
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消操作",
        });
      });
  }

  private returnGoods() {
    ElMessageBox.confirm("此操作将[确认返货], 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const inspect = this.entity as Inspect;
        this.service.action(
          "/api/ins/inspect/return_goods",
          inspect,
          (data: any) => {
            ElMessage({ type: "success", message: data.message });
            this.load(this.id);
          },
          function (error: Error) {
            ElMessage.error(error.message);
          }
        );
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消操作",
        });
      });
  }

  download() {
    const inspect = this.entity as Inspect;
    const aTag = document.createElement("a");
    aTag.href = inspect.contractWordUrl!;
    aTag.click();
  }
}
</script>

<style lang="scss">
.box-card {
  width: 480px;
  min-height: 320px;
  float: left;
  margin-right: 40px;
}

.card-header {
  display: flex;
  justify-content: space-between;
}

.split-button {
  margin-left: 10px;
}

.contract-content {
  height: calc(100vh - 370px);
  width: 1000px;
  margin: 0 auto;
  border: 1px solid gray;
  padding: 10px 60px;
}

.delegate-btns {
  margin-bottom: 20px;
}

.express .el-form-item__label {
  line-height: normal;
}

.express .el-form-item {
  align-items: center;
}

.express .el-row {
  margin-bottom: 0;
}
</style>
